<script setup>
   // import circleExclamationSvg from '@/assets/fontawesome/regular/circle-exclamation.svg'
import InlineSvg from 'vue-inline-svg'

defineProps({
  message: {
    type: String,
    default: '',
    required: true
  }
})
</script>

<template>
  <div class="flex gap-1 font-mono text-red-500 text-sm">
    <InlineSvg
      :src="require('@/assets/fontawesome/regular/circle-exclamation.svg')"
      class="w-4 h-4 shrink-0 mt-1"/>

    <span class="first-letter:uppercase leading-6">{{ message }}</span>
  </div>
</template>
